import { DateWithFormat } from '../shared/date-with-format';

export class PublicationModel {
  id: number;
  name: string;
  description: string;
  descriptionEn: string;
  publicationDate: DateWithFormat = new DateWithFormat();
  userId: number;
  deleted: boolean;
  version: number;
}



// WEBPACK FOOTER //
// C:/Users/Sylwia/Desktop/12.02/ecv_manager_frontend/src/app/network/publication.model.ts